<template>
  <RouterLink
    ref="routerLink"
    :to="props.path"
    class="duration-50 cursor-pointer pb-2 font-medium text-contrast-muted transition-all duration-75 hover:text-primary">
    {{ props.title }}
  </RouterLink>
</template>

<script setup lang="ts">
  import { useRoute } from 'vue-router'

  interface Props {
    title: string
    path: string
  }

  const props = defineProps<Props>()
  const route = useRoute()

  const isActive = computed(() => {
    const pathWithoutQuery = props.path.split('?')[0]
    return route.path === pathWithoutQuery
  })

  defineExpose({ isActive })
</script>

<style lang="css" scoped>
  .router-link-exact-active {
    color: var(--sm-primary);
  }
</style>
